/// <reference lib="dom" />
import { useRef, useState } from "hono/jsx/dom";
import { EULA_TEXT } from "@/features/legal/constants.ts";
import { marked } from "marked";

export function EulaRegistration() {
  const [agreed, setAgreed] = useState(false);
  const dialogRef = useRef<HTMLDialogElement>(null);

  function openModal(e: Event) {
    e.preventDefault();
    dialogRef.current?.showModal();
  }

  function handleAgree() {
    setAgreed(true);
    dialogRef.current?.close();
  }

  function handleCancel() {
    dialogRef.current?.close();
  }

  return (
    <>
      {/* Hidden input for form submission */}
      {agreed && <input type="hidden" name="eula_agreed" value="on" />}

      <div className="form-control">
        <label className="label cursor-pointer justify-start gap-4">
          <input
            type="checkbox"
            className="checkbox checkbox-primary"
            checked={agreed}
            required
            onClick={(e: Event) => {
              if (!agreed) {
                e.preventDefault();
                openModal(e);
              }
            }}
            onChange={() => {}} // Controlled component
          />
          <span className="label-text">
            I agree to the{" "}
            <a href="#" onClick={openModal} className="link link-primary">
              End User License Agreement
            </a>
          </span>
        </label>
      </div>

      <dialog ref={dialogRef} className="modal">
        <div className="modal-box w-11/12 max-w-5xl">
          <h3 className="font-bold text-lg">End User License Agreement</h3>
          <div className="py-4 max-h-[60vh] overflow-y-auto text-sm border p-4 rounded bg-base-200">
            <div
              className="prose prose-sm max-w-none"
              dangerouslySetInnerHTML={{
                __html: marked.parse(EULA_TEXT) as string,
              }}
            />
          </div>
          <div className="modal-action">
            <button
              className="btn btn-ghost mr-2"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleAgree}
            >
              I Agree
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
}
